export default __webpack_public_path__ + "355c9476ae3ca57e720cb6841a5259fe.png";